(() => {
  if (window.__paydayOfferBound) return;
  window.__paydayOfferBound = true;

  const formatMoney = (cents, format) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    const n = Math.round((Number(cents) || 0) / 100).toString();
    return String(format || '₹{{amount_no_decimals}}').replace(/\{\{\s*amount[^}]*\}\}/g, n);
  };

  const BLOCKED_SKUS = {
    RC021A: true,
    RC039P: true,
    RC038: true,
    RC040: true,
    RC049P: true,
    RC434: true,
    RC465P: true,
  };

  const isBlockedSku = (sku) => BLOCKED_SKUS[String(sku || '').trim().toUpperCase()] === true;

  const findOffer = (event) => {
    const origin = event.target instanceof Element ? event.target : null;
    const card = origin && origin.closest('product-card');
    if (card) return card.querySelector('[data-payday-offer]');
    return document.querySelector('.product-details [data-payday-offer]');
  };

  document.addEventListener(
    'variant:update',
    (event) => {
      const offer = findOffer(event);
      if (!offer) return;

      const resource = event.detail && event.detail.resource;
      if (isBlockedSku(resource && resource.sku)) {
        offer.hidden = true;
        return;
      }
      offer.hidden = false;

      const productId = offer.getAttribute('data-product-id');
      const incomingId = event.detail && event.detail.data && event.detail.data.productId;
      const newProduct = event.detail && event.detail.data && event.detail.data.newProduct;

      if (newProduct && newProduct.id) {
        offer.setAttribute('data-product-id', String(newProduct.id));
      } else if (productId && incomingId && String(incomingId) !== String(productId)) {
        return;
      }

      const saleCents = Number(resource && resource.price);
      if (!Number.isFinite(saleCents) || saleCents <= 0) return;

      const percent = Number(offer.getAttribute('data-percent')) || 30;
      const priceEl = offer.querySelector('[data-payday-price]');
      if (priceEl) {
        priceEl.textContent = formatMoney(Math.round((saleCents * (100 - percent)) / 100), offer.getAttribute('data-money-format'));
      }
    },
    true
  );
})();
